import { Link } from "react-router-dom";
import { AlertOctagon, Info as InfoIcon } from "lucide-react";
import { fmtDate } from "../../lib/status";

export function CustomerIncidentsTab({ profile }) {
  const incidents = profile.incidents || [];
  return (
    <div className="space-y-4" data-testid="cp-incidents">
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600 flex items-start gap-2" data-testid="cp-incidents-damage-note">
        <InfoIcon className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
        <span>{profile.damage_note}</span>
      </div>

      {incidents.length === 0 ? (
        <div className="rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-500" data-testid="cp-incidents-empty">
          No incidents linked to this customer's bookings.
        </div>
      ) : (
        <ul className="space-y-2">
          {incidents.map((i) => (
            <li key={`${i.incident_id}-${i.booking_id}`} className="rounded-xl border border-slate-200 bg-white p-4" data-testid={`cp-incident-${i.incident_id}`}>
              <div className="flex flex-wrap items-start justify-between gap-2">
                <div className="flex items-center gap-2">
                  <AlertOctagon className="w-4 h-4 text-red-600" />
                  <Link to={`/app/incidents/${i.incident_id}`} className="font-semibold text-slate-900 hover:underline">{i.title}</Link>
                </div>
                <span className="text-xs text-slate-500 capitalize">{(i.impact_level || "").replace(/_/g, " ")}</span>
              </div>
              <div className="text-sm text-slate-600 mt-1">
                <Link to={`/app/bookings/${i.booking_id}`} className="hover:underline">{i.booking_reference}</Link>
                {i.vehicle_name && ` · ${i.vehicle_name}`}
                {i.occurred_at && ` · ${fmtDate(i.occurred_at)}`}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
